import apiClient from '../../api/apiClient';
import API_CONFIG from '../../config/api';
import { useAuth } from '../../context/AuthContext';
import { useSelection } from '../../SelectionContext';

export function useHRReportScope() {
  const { user, hasPermission } = useAuth();
  const { selectedCompany, selectedWarehouse } = useSelection();
  const isSystem = Number(user?.is_superadmin) === 1 || user?.role === 'SysAdmin';
  const requested = selectedCompany || (!isSystem ? user?.company_id : null);
  const companyId = Number.isSafeInteger(Number(requested)) && Number(requested) > 0 ? Number(requested) : null;
  return { userId: user?.id, companyId, warehouseId: selectedWarehouse || null,
    moduleScope: 'hr-reports', allowed: Boolean(user && hasPermission('Ressources Humaines.Rapports.view')) };
}

export function reportHeaders(companyId: number | null) {
  if (!companyId) throw new Error('Sélectionnez une entreprise.');
  const token = localStorage.getItem('authToken') || localStorage.getItem('token');
  if (!token) throw new Error('La session a expiré. Reconnectez-vous.');
  return { Authorization: `Bearer ${token}`, 'X-Company-Id': String(companyId) };
}

export async function getHRReportResource<T>(path: string, companyId: number | null, signal: AbortSignal): Promise<T> {
  const response = await apiClient.get(API_CONFIG.url(path), { headers: reportHeaders(companyId), signal });
  if (!response.data?.success || !response.data.data) throw new Error(response.data?.message || 'Données RH indisponibles.');
  return response.data.data;
}

export function reportError(error: any): string {
  return error?.response?.data?.message || error?.message || 'Impossible de charger les données RH.';
}

export function reportNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') return undefined;
  const number = Number(value);
  return Number.isFinite(number) ? number : undefined;
}

export const reportMoney = (value: unknown) => {
  const number = reportNumber(value);
  return number === undefined ? 'Non disponible' : `${number.toLocaleString('fr-FR', { maximumFractionDigits: 2 })} FCFA`;
};
